import '@/assets/styles/toast.scss';
import { isDevelopment } from '@/config';
import { i18n } from '@/plugins/i18n.js';
import Noty from 'noty';

const defaults = {
  layout: 'topCenter',
  timeout: 5000,
  progressBar: true,
  closeWith: ['click'],
};

const Toast = {
  options: {},

  configure(options, maxVisible = 6) {
    Noty.setMaxVisible(maxVisible);

    this.options = Object.assign({}, defaults, options);
    return this;
  },

  show(text, type = 'alert', options = {}) {
    const params = Object.assign({}, this.options, options, {
      type,
      text,
    });

    const toast = new Noty(params);
    return toast.show();
  },

  success(text, options = {}) {
    return this.show(text, 'success', options);
  },

  error(error, options = {}, defaultError) {
    let text = defaultError ? defaultError : i18n.t('toast.error');
    // A plain string is the message itself (the widespread `$toast.error($t(...))`
    // call sites); the object branches below handle actual error objects.
    if (typeof error === 'string' && error) {
      text = error;
    } else if (error.type && i18n.te(`shared.error.${error.type}`)) {
      text = i18n.t(`shared.error.${error.type}`);
    } else if (
      error.response &&
      error.response.data &&
      error.response.data.code &&
      i18n.te(`error.code.${error.response.data.code}`)
    ) {
      text = i18n.t(`error.code.${error.response.data.code}`);
    } else if (isDevelopment && error instanceof Error) {
      text = error.message;
    }

    return this.show(text, 'error', options);
  },

  warning(text, options = {}) {
    return this.show(text, 'warning', options);
  },

  info(text, options = {}) {
    return this.show(text, 'info', options);
  },

  cancel(text, callback) {
    const toast = this.show(text, 'info', {
      buttons: [
        Noty.button(i18n.t('toast.cancel'), '', () => {
          callback();
          toast.close();
        }),
      ],
    });
    return toast.show();
  },
};

export default {
  install: function (Vue, options) {
    const toast = Toast.configure(options);
    Vue.prototype.$toast = toast;
    Vue.toast = toast;
  },
};
